"use client";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import _ from "lodash";
import React, { useEffect } from "react";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { CardTestimonial } from "@/components/shared/CardTestimionial";
import Title from "@/components/shared/Title";
import { useTranslation } from "@/hooks/useTranslation";
import getFeedbacksPagination from "@/lib/guestbook/getFeedbacksPagination";
import type { Feedback } from "@/payload-types";

const Testimonial = () => {
  const { t } = useTranslation();
  const [feedbacks, setFeedbacks] = React.useState<Feedback[]>([]);

  useEffect(() => {
    getFeedbacksPagination(1, 10).then((data) => {
      setFeedbacks(data?.docs || []);
    });
  }, []);

  return !_.isEmpty(feedbacks) ? (
    <section id="testimonial" className="bg-white">
      <div className="w-full">
        <Title
          title={t({
            de: "Das sagen unsere Gäste",
            en: "What Our Guests Say",
          })}
          desc={t({
            de: "Echte Geschichten und ehrliche Erlebnisse unserer Gäste.",
            en: "Real stories and honest experiences from our guests.",
          })}
        />

        <div className="mx-auto mt-12">
          <Swiper
            modules={[Navigation, Pagination]}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            freeMode
            loop
            slidesPerView="auto"
            speed={700}
            className="mt-16 w-full"
          >
            {feedbacks.map((feedback) => (
              <SwiperSlide key={feedback.id} className="!max-w-96 p-5">
                <CardTestimonial feedback={feedback} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  ) : (
    <></>
  );
};

export default Testimonial;
